import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { cart } from '@/theme/Cart';
import { QuantitySpinner } from '../QuantitySpinner/QuantitySpinner';

@Component
export class CartItemRow extends ThemeComponent {
    @Prop item!: Shopify.Liquid.LineItem;

    @Ref({ required: false }) quantity!: QuantitySpinner;
    @Ref({ required: false }) removeItemButton!: HTMLButtonElement[];
    @Ref({ required: false }) addToWishlistButton!: HTMLButtonElement;

    init() {

        // Listen for item remove clicks
        for (const button of this.removeItemButton) {
            this.$listen(button, 'click', () => this.handleQuantity(0));
        }

        // Subscribe to quantity change
        if (this.quantity) {
            this.$subscribe(this.quantity.onChange, (quantity) => {
                this.handleQuantity(quantity).catch((e) => {
                    this.$log.error(`Update quantity failed`, { e });
                });
            });
        }

        // Listen for add to wishlist button state change
        this.listenForAddToWishlistButtonStateChange();
    }

    async handleQuantity(quantity: number) {

        // Find matching cart item
        let matchingItem = null;
        for (const item of cart.items) {
            if (item.variantId === this.item.id) {
                matchingItem = item;
            }
        }
        if (matchingItem === null) {
            this.$log.error(`No matching item found`);
            return;
        }

        // Attemp quantity update
        try {
            if (quantity === 0) {

                // Remove item
                await cart.removeItem(matchingItem);
            } else {

                // Change item
                await cart.changeItem(matchingItem, quantity, null);
            }
        } catch (event: unknown) {
            const { message } = event as Error;
            this.$log.error('Cart item quantity update error', message);
        }

        // Dispatch event for other components to listen to
        document.dispatchEvent(new Event('cartChanged'));
    }

    listenForAddToWishlistButtonStateChange() {

        // Ensure wishlist button exists
        if (this.addToWishlistButton === null) {
            return;
        }

        // Ensure item was not added to a wishlist previously, before cart
        if (this.addToWishlistButton.classList.contains('swym-added')) {
            return;
        }

        // Init observer, listen for swym-added class and remove item from cart
        const observer = new MutationObserver(() => {
            if (this.addToWishlistButton.classList.contains('swym-added')) {
                observer.disconnect();
                void this.handleQuantity(0);
            }
        });

        // Only start observing after button click
        this.$listen(this.addToWishlistButton, 'click', () => {
            observer.observe(this.addToWishlistButton, {
                attributes : true,
                attributeFilter : ['class']
            });
        });
    }
}
